import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a9b89d4&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4a9b89d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9b89d4",
  null
  
)

/* custom blocks */
import block0 from "@/lang/products/broadband?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230928163347%2Fpages%2Fcompare-tv-broadband-phone%2Findex.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsBroadbandCapturePoint: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/products/broadband/capture-point.vue').default,ProductsHumanising: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/products/humanising.vue').default,ProductsMoreInfo: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/products/more-info.vue').default,WidgetsAlertMessage: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/alert-message.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/site/feefo.vue').default})
